import { heroEntry } from '@/content/site';
import { ScrollReveal } from '@/components/ScrollReveal';
import { HeroChatDemo } from '@/components/HeroChatDemo';
import './Hero.css';
import './MobileHero.css';

/** Hero mobile: chat a pantalla completa primero; copy debajo (CTA solo en sticky). */
export function MobileHero() {
  return (
    <section className="hero hero--mobile" id="inicio">
      <div className="hero__visual hero__visual--screen">
        <div className="container hero__visual-inner">
          <HeroChatDemo />
        </div>
      </div>

      <div className="container hero__copy-block">
        <ScrollReveal className="hero__copy">
          <span className="hero__eyebrow">{heroEntry.eyebrow}</span>
          <h1 className="hero__title">
            {heroEntry.headline}
            <span className="hero__title-highlight">{heroEntry.titleAccent}</span>
          </h1>
          <p className="hero__subtitle">{heroEntry.subtitle}</p>
        </ScrollReveal>
      </div>
    </section>
  );
}
